import {defineRecipe} from '@chakra-ui/react'

export const buttonTheme = defineRecipe({
  base: {borderRadius: 'lg', colorPalette: 'slate'},
  variants: {
    size: {
      md: {paddingInline: '8', paddingBlock: '22px', fontSize: 'xs'},
      lg: {fontSize: 'sm'},
    },
  },
})
